import { render, staticRenderFns } from "./VideosWidget.vue?vue&type=template&id=2f69c272&scoped=true"
import script from "./VideosWidget.vue?vue&type=script&lang=js"
export * from "./VideosWidget.vue?vue&type=script&lang=js"
import style0 from "./VideosWidget.vue?vue&type=style&index=0&id=2f69c272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f69c272",
  null
  
)

export default component.exports